import { useContext, useState } from "react";
import Button from "@mui/material/Button";
import { styled } from "@mui/material/styles";
import Dialog from "@mui/material/Dialog";
import DialogTitle from "@mui/material/DialogTitle";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import { StreamContext } from "contexts/Stream";
import { Checkbox, FormControlLabel, FormGroup } from "@mui/material";
import { grey } from "@mui/material/colors";
import { DYNAMIC_BASE_URL, STREAM_TYPES } from "shared/enum";

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
  zIndex: 1300,
  "& .MuiPaper-root": {
    alignItems: "center",
    backgroundColor: "rgba(0, 0, 0, 0.3)",
    padding: 25,
    borderRadius: 12,
  },
  "& .MuiDialogContent-root": {
    padding: theme.spacing(2),
  },
  "& .MuiDialogActions-root": {
    padding: theme.spacing(1),
  },
}));

type StreamingAvailablePopupProps = {
  handleStream: (shouldStream: boolean) => void;
};

export default function StreamingAvailablePopup({ handleStream }: StreamingAvailablePopupProps) {
  const {
    setStreamingState,
    setTurntableState,
    streamingState,
    checkSessionAvailability,
    setStreamViewType,
  } = useContext(StreamContext);
  const [open, setOpen] = useState(true);
  const handleOpen = () => setOpen(true);
  const handleClose = () => {
    setOpen(false);

    setStreamingState((prev) => ({
      ...prev,
      isStreamingAvailable: false,
      callStreamingAvailableAPI: true,
    }));

    setTurntableState((prev) => ({
      ...prev,
      isTurntable: true,
    }));
  };

  return (
    <>
      <Button variant="outlined" onClick={handleOpen}>
        Open dialog
      </Button>
      <BootstrapDialog onClose={handleClose} aria-labelledby="customized-dialog-title" open={open}>
        <DialogTitle
          sx={{ m: 0, p: 2, color: "#fff", fontWeight: 600, fontSize: 20 }}
          id="customized-dialog-title"
        >
          3D LIVE STREAM AVAILABLE
        </DialogTitle>
        <IconButton
          aria-label="close"
          onClick={handleClose}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[100],
          }}
        >
          <CloseIcon />
        </IconButton>

        <Button
          variant="contained"
          sx={{
            width: "90%",
            backgroundColor: "#000",
            borderRadius: "64px",
            color: "#fff",
            ":hover": {
              backgroundColor: "#000",
            },
          }}
          onClick={() => {
            checkSessionAvailability()
              .then((data) => {
                setTurntableState((prev) => ({
                  ...prev,
                  isTurntable: data?.status !== 200,
                }));

                setStreamingState((prev) => ({
                  ...prev,
                  isStreamingAvailable: data?.status === 200,
                  callStreamingAvailableAPI: data?.status !== 200,
                  isDontNotify: false,
                }));

                setStreamViewType(
                  data?.status === 200 ? STREAM_TYPES.STREAMING : STREAM_TYPES.TURNTABLE,
                );
              })
              .catch((err) => {
                setTurntableState((prev) => ({
                  ...prev,
                  isTurntable: true,
                }));

                setStreamingState((prev) => ({
                  ...prev,
                  isStreamingAvailable: false,
                  callStreamingAvailableAPI: true,
                  isDontNotify: false,
                }));

                setStreamViewType(STREAM_TYPES.TURNTABLE);
              });

            handleStream(true);
          }}
        >
          <img
            src={`${DYNAMIC_BASE_URL}/assets/explore.png`}
            alt="explore.png"
            style={{
              marginRight: 10,
            }}
          />
          Explore
        </Button>

        {/* <Button onClick={handleClose}>Close</Button> */}

        <FormGroup>
          <FormControlLabel
            sx={{
              color: grey[100],
            }}
            control={
              <Checkbox
                checked={streamingState.isDontNotify}
                onClick={() => {
                  setStreamingState((prev) => ({
                    ...prev,
                    isDontNotify: !prev.isDontNotify,
                  }));
                }}
                sx={{
                  color: grey[100],
                  "&.Mui-checked": {
                    color: grey[100],
                  },
                }}
              />
            }
            label="Don't notify me again."
          />
        </FormGroup>
      </BootstrapDialog>
    </>
  );
}
